import get from 'lodash/get';
export const translations = get(window, 'wix.translations', {});



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/i18n/translations.js